/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Grid, Button, Typography } from "@mui/material";
import { toast } from 'react-toastify';
import FilterListIcon from '@mui/icons-material/FilterList';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { isSuperAdmin } from "../../../../helpers/user";
// theme css file
import { SIX_MONTHS_BEFORE_DATE } from '../../userActivities.constants';

import TextInputField from "../../../../components/textInputField/TextInputField";
import SelectField from "../../../../components/selectField";
import InfoIconWithText from "../../../../components/infoIconWithText";
import { validateFilters, isMandatoryFieldSelected  } from "./filters.helpers";
import styles from "./filters.module.scss";
import { HTTP_METHODS, INITIAL_FILTERS, DETAIL_TYPES } from "../../userActivities.constants";
import { removeEmptyProperties } from "../../../../helpers/general"
import { useTranslation } from 'react-i18next'

const searchStyle = {
  // height: '50px',
  
  '&:disabled': {
    backgroundColor: 'rgba(102, 90, 71, 0.15) !important',
  }
}

function Filters({ filters, setFilters, getUserActivities }) {

  const [showMoreFilters, setShowMoreFilters] = useState(false)
  const [errors, setErrors] = useState({})
  const [shouldDisableSearch, setShouldDisableSearch] = useState(false);
  const { t } = useTranslation()

  const handleFilterChange = (name, value) => {
    const updatedFilters = { ...filters, [name]: value }
    const errorMsgs = validateFilters(updatedFilters);
    setErrors(errorMsgs)
    setFilters(updatedFilters)
  };

  const handleSearch = () => {
    setShouldDisableSearch(true)
    if(!isMandatoryFieldSelected(filters)) {
      toast.warning('You should select either email, guid, userid, detailType, method or url')
      return;
    }
    const errorMsgs = validateFilters(filters);
    if (Object.keys(removeEmptyProperties(errorMsgs)).length >= 1) {
      setErrors(errorMsgs)
      return
    }
    setErrors({})
    getUserActivities()
  }

  useEffect(() => {
    setShouldDisableSearch(false)
  }, [filters])

  return (
    <>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          <h1>{t('user-activities-audits-for-single-user')}</h1>
          <Grid container spacing={2}>
            <Grid style={{ marginTop: "-12px" }} item>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={[
                  'DatePicker',
                  'DesktopDatePicker',
                ]} className={{ display: 'flex' }}>
                  <DemoItem label={
                     <InfoIconWithText label={t('user-activities-start-date')} helpText={t('user-activities-start-date-help-text')} />
                  }
                  >
                    <DateTimePicker
                      value={filters.startTime}
                      onChange={(newDate) => handleFilterChange('startTime', newDate)}
                      minDate={SIX_MONTHS_BEFORE_DATE}
                      disableFuture={true}
                      inputFormat="yyyy-MM-dd'T'HH:mm"
                      inputProps={{
                        style: { fontSize: '16px' } // Adjust font size here
                      }}
                    />
                  </DemoItem>
                  <DemoItem label={
                    <InfoIconWithText style ={{fontSize:"10px"}} label={t('user-activities-end-date')} helpText={t('user-activities-end-date-help-text')} />
                  }>
                    <DateTimePicker
                      value={filters.endTime}
                      onChange={(newDate) => handleFilterChange('endTime', newDate)}
                      disableFuture={true} 
                      inputFormat="yyyy-MM-dd'T'HH:mm"
                      inputProps={{
                        style: { fontSize: '16px' } // Adjust font size here
                      }}
                      />
                    {errors.endTime && (
                      <Typography variant="body2" color="error">
                        {errors.endTime}
                      </Typography>
                    )}
                  </DemoItem>
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
            <Grid item className={styles.gridItem}>
              <TextInputField
                placeholder="example@email.com"
                label={<InfoIconWithText label={t('user-activities-email')} helpText={t('user-activities-email-help-text')} />}
                disabled={!isSuperAdmin()}
                value={filters.email}
                styles={{ width: "300px" }}
                error={errors.email}
                onChange={(e) => handleFilterChange('email', e.target.value)}
              />

            </Grid>
            <Grid item className={styles.gridItem}>
              {
                showMoreFilters ?
                  <Button onClick={() => setShowMoreFilters(false)} className={styles.filterBtn} startIcon={<FilterListIcon />}>
                    {t('user-activities-less-filters')}
                  </Button> :
                  <Button onClick={() => setShowMoreFilters(true)} className={styles.filterBtn} startIcon={<FilterListIcon />}>
                    {t('user-activities-more-filters')}
                  </Button>
              }
            </Grid>
          </Grid>
          {
            showMoreFilters && <Grid className={styles.moreFiltersContainer} container>
              {/* <Grid className={styles.filterItem} item xs={4}>
                <TextInputField
                  placeholder="User Id"
                  label={<InfoIconWithText label="UserId" helpText="UserId shoul " />}
                  value={filters.userid}
                  styles={{ width: "82%" }}
                  onChange={(e) => handleFilterChange('userid', e.target.value)}
                  error={errors.userid}
                />
              </Grid> */}
              <Grid className={styles.filterItem} item xs={4}>
                <SelectField
                  options={HTTP_METHODS}
                  label={<Typography >{t('user-activities-http-method')}</Typography>}
                  id={"method"}
                  value={filters.method}
                  styles={{ width: "82%" }}
                  onChange={(e) => handleFilterChange('method', e?.target?.value)}
                />
              </Grid>
              <Grid className={styles.filterItem} item xs={4}>
                <TextInputField
                  placeholder={t('user-activities-limit')}
                  label={<Typography >{t('user-activities-limit')}</Typography>}
                  value={filters.limit}
                  styles={{ width: "82%" }}
                  onChange={(e) => handleFilterChange('limit', e?.target?.value)}
                  error={errors.limit}
                />
              </Grid>
              <Grid className={styles.filterItem} item xs={4}>
                <SelectField
                  options={DETAIL_TYPES}
                  label={<InfoIconWithText label={t('user-activities-detail-type')} helpText={t('user-activities-detail-type-help-text')} />}
                  id={"detailType"}
                  value={filters.detailType}
                  styles={{ width: "82%" }}
                  onChange={(e) => handleFilterChange('detailType', e?.target?.value)}
                />
              </Grid>
              <Grid className={styles.filterItem} item xs={4}>
                <TextInputField
                  placeholder={t('user-activities-guid')}
                  label={<InfoIconWithText label={t('user-activities-guid')} helpText={t('user-activities-coming-soon')} />}
                  //label={<Typography>Guid</Typography>}
                  value={filters.guid}
                  styles={{ width: "82%" }}
                  onChange={(e) => handleFilterChange('guid', e?.target?.value)}
                  error={errors.guid}
                  disabled
                />
              </Grid>
              <Grid className={styles.filterItem} item xs={4}>
                <TextInputField
                  placeholder="URL"
                  label={<InfoIconWithText label="URL" helpText={t('user-activities-url-help-text')} />}
                  value={filters.url}
                  styles={{ width: "82%" }}
                  
                  onChange={(e) => handleFilterChange('url', e.target.value)} />
              </Grid>


            </Grid>
          }
          <Grid style={{ marginTop: 15 }} container>
            <Grid item xs={8}>
              <Button
                onClick={handleSearch}
                className={styles.searchBtn}
                variant="contained"
                disabled={shouldDisableSearch}
                sx={{ ...searchStyle }} >
                {t('user-activities-search')}
              </Button>
              {
                showMoreFilters &&
                <Button
                  onClick={() => setShowMoreFilters(false)}
                  className={styles.closeBtn}
                  variant="contained"
                  disabled={false} >
                  {t('user-activities-close')}
                </Button>
              }
            </Grid>
            {
              showMoreFilters &&
              <Grid item>
                <Button
                  onClick={() => {
                    setFilters(INITIAL_FILTERS)
                  }}
                  className={styles.clearBtn}
                  variant="outlined"
                  disabled={false} >
                  {t('user-activities-clear-all')}
                </Button>
              </Grid>
            }

          </Grid>
        </div>
      </div>
    </>
  );
}

export default Filters;
